import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Report } from '@reporting/services/queries/report';
import { Observable } from 'rxjs';

@Injectable()
export class ReportDataResolver {
    constructor(protected report: Report) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
        if (route.data['report'] == null) {
            throw new Error('Report target is undefined');
        }

        return this.report
            .name(route.data['report'])
            .id(route.params.id ?? null)
            .page(1)
            .get();
    }
}
